/**
 * LLD-SPA-004 / §31.7 — "the bundle carries no environment value… all of it arrives in one
 * document fetched at boot." The deploy stage writes `config.json` per environment (home API
 * base URL and the environment name, and nothing else); this module is the only place that reads
 * it, and the only place a base URL is allowed to come from.
 */

export interface BootConfig {
  readonly environment: string
  readonly apiBaseUrl: string
}

function isBootConfig(value: unknown): value is BootConfig {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as Record<string, unknown>).environment === 'string' &&
    typeof (value as Record<string, unknown>).apiBaseUrl === 'string'
  )
}

export async function loadBootConfig(): Promise<BootConfig> {
  const response = await fetch('/config.json', { cache: 'no-store' })
  if (!response.ok) {
    throw new Error(`GET /config.json returned ${response.status}`)
  }
  const body: unknown = await response.json()
  if (!isBootConfig(body)) {
    throw new Error('/config.json did not match { environment: string, apiBaseUrl: string }')
  }
  return body
}
